import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileBend: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-bend, document"><path d="M12.75 2.75H4.75V21.25H19.25V9.25L12.75 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M12.75 3.25464V9.25007H18.7501" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconFileBend;
